import { BeneficiaryAccountStep } from './BeneficiaryAccountStep';
import { BillPaymentStep } from './BillPaymentStep';
import { BorrowerStep } from './BorrowerStep';
import { CustodianStep } from './CustodianStep';
import { CustomCcbStep } from './CustomCcbStep';
import { FundingStep } from './FundingStep';
import { OriginatorStep } from './OriginatorStep';
import { ProductStep } from './ProductStep';
import { QRCodeStep } from './QRCodeStep';
import { ReviewStep } from './ReviewStep';
import { SimulationStep } from './SimulationStep';
import { SimulationV2Step } from './SimulationV2Step';
import { SubscribersStep } from './SubscribersStep';
import { VariablesStep } from './VariablesStep';
import ConsignedStep from './ConsignedStep/ConsignedStep';
import SplitPaymentStep from './SplitPaymentStep/SplitPaymentStep';
import { ConsigneeOrganType } from './ConsignedStep/interfaces';
import FgtsStep from './FgtsStep/FgtsStep';
import { TProducts } from 'modules/products/context';
import { EBeneficiaryType } from 'modules/products/context/ProductsProvider/products.interfaces';

export const getApplicationSteps = (
  showProduct: boolean,
  product?: TProducts | null,
) => {
  const consigneeType = product?.organ_type as ConsigneeOrganType | undefined;

  // Fluxo Siape e CT
  const consigneeSteps = [
    {
      title: 'Funding',
      component: <FundingStep />,
    },
    ...(showProduct
      ? [
          {
            title: 'Produto',
            component: <ProductStep />,
          },
        ]
      : []),
    {
      title: 'Consulta de margem',
      component: <ConsignedStep />,
    },
    {
      title: 'Valores da Solicitação',
      component: <SimulationV2Step />,
    },
    {
      title: 'Tomador',
      component: <BorrowerStep isUnicPerson />,
    },
    ...(product?.beneficiary_type ===
    EBeneficiaryType.EXTERNAL_REGISTERED_ACCOUNT
      ? [
          {
            title: 'Conta Beneficiária',
            component: <BeneficiaryAccountStep />,
          },
        ]
      : []),
    {
      title: 'Split de Pagamento',
      component: <SplitPaymentStep />,
    },
    {
      title: 'Ficou tudo certo?',
      component: <ReviewStep />,
    },
  ];

  // Fluxo FGTS
  const fgtsSteps = [
    {
      title: 'Funding',
      component: <FundingStep />,
    },
    ...(showProduct
      ? [
          {
            title: 'Produto',
            component: <ProductStep />,
          },
        ]
      : []),
    {
      title: 'Consulta de saldo',
      component: <FgtsStep />,
    },
    {
      title: 'Valores da Solicitação',
      component: <SimulationV2Step />,
    },
    {
      title: 'Tomador',
      component: <BorrowerStep isUnicPerson />,
    },
    {
      title: 'Assinantes',
      component: <SubscribersStep />,
    },
    {
      title: 'Ficou tudo certo?',
      component: <ReviewStep />,
    },
  ];

  // Fluxo Default (todos os demais produtos)
  const defaultSteps = [
    {
      title: 'Originador',
      component: <OriginatorStep />,
    },
    {
      title: 'Funding',
      component: <FundingStep />,
    },
    ...(showProduct
      ? [
          {
            title: 'Produto',
            component: <ProductStep />,
          },
        ]
      : []),
    {
      title: 'Tomador',
      component: <BorrowerStep />,
    },
    {
      title: 'Custodiante',
      component: <CustodianStep />,
    },
    {
      title: 'Conta Beneficiária',
      component: <BeneficiaryAccountStep />,
    },
    {
      title: 'Boletos para desembolso',
      component: <BillPaymentStep />,
    },
    {
      title: 'Pix Copia e Cola',
      component: <QRCodeStep />,
    },
    {
      title: 'Valores da Solicitação',
      component: <SimulationStep />,
    },
    {
      title: 'Split de Pagamento',
      component: <SplitPaymentStep />,
    },
    {
      title: 'Template de CCB',
      component: <CustomCcbStep />,
    },
    {
      title: 'Assinantes',
      component: <SubscribersStep />,
    },
    {
      title: 'Campos adicionais',
      component: <VariablesStep />,
    },
    {
      title: 'Ficou tudo certo?',
      component: <ReviewStep />,
    },
  ];

  const steps = {
    [ConsigneeOrganType.CT]: consigneeSteps,
    [ConsigneeOrganType.SIAPE]: consigneeSteps,
    [ConsigneeOrganType.INSS]: consigneeSteps,
    [ConsigneeOrganType.FGTS]: fgtsSteps,
  };

  if (!consigneeType) {
    return defaultSteps;
  }

  return steps[consigneeType];
};
